import type { OnDestroy, OnInit } from '@angular/core';
import { inject } from '@angular/core';
import type { UntypedFormGroup } from '@angular/forms';
import { NonNullableFormBuilder } from '@angular/forms';

import { Directive, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { CSS_RESTRICTIONS } from '@common/constants';

@Directive()
export abstract class WebBaseControlTypedSettingsComponent<T extends UntypedFormGroup> implements OnInit, OnDestroy {
    @Input() public itemForm!: T;
    @Output() public cancelEvent: EventEmitter<void> = new EventEmitter();

    public readonly CSS_RESTRICTIONS = CSS_RESTRICTIONS;

    protected cachedInitValue = null;

    protected readonly unsubscribe$ = new Subject<void>();
    protected readonly fb: NonNullableFormBuilder = inject(NonNullableFormBuilder);

    public initSubscriptions(): void {}
    public ngOnInit(): void {
        this.cachedInitValue = this.itemForm.value;

        this.itemForm.valueChanges.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
            this.itemForm.markAsDirty({ onlySelf: true });
        });

        this.initSubscriptions();
    }

    public onSave(): void {
        this.itemForm.markAsPristine({ onlySelf: true });
        this.cancelEvent.emit();
    }

    public onReset(): void {
        if (this.itemForm.dirty) {
            this.itemForm.patchValue(this.cachedInitValue);
            this.itemForm.markAsPristine({ onlySelf: true });
        }

        this.cancelEvent.emit();
    }

    public onCancel(): void {
        this.cancelEvent.emit();
    }

    public ngOnDestroy(): void {
        if (this.itemForm.dirty) {
            this.itemForm.patchValue(this.cachedInitValue);
        }

        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

    @HostListener('document:keydown.enter')
    public onEnterKeyPress(): void {
        if (this.saveDisablePredicate) {
            return;
        }

        this.onSave();
    }

    @HostListener('document:keydown.escape', ['$event'])
    public onEscapeKeyPress(event: KeyboardEvent): void {
        event.stopPropagation();
        this.onCancel();
    }

    public get saveDisablePredicate(): boolean {
        return false;
    }
}
